import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	manageWarnings: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalSave: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningsSetForAllVersionsInThisProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateWarningConfigFailed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openPullRequests: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openPullRequestsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openReviews: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openReviewsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreviewedCode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreviewedCodeDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failingBuilds: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failingBuildsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openPullRequestsDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openReviewsDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreviewedCodeDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failingBuildsDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningsSetForAllVersionsInThisProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	manageWarnings: {
		id: 'software-releases-manage-warnings.manage-warnings',
		defaultMessage: 'Manage warnings',
		description:
			'Title for modal that explains to user what conditions a warning would show for in the versions page. This could be when there are failing builds, unreviewed code or open pull requests',
	},
	modalSave: {
		id: 'software-releases-manage-warnings.modal-save',
		defaultMessage: 'Save',
		description: 'Saves the version warning configuration for the current project',
	},
	modalCancel: {
		id: 'software-releases-manage-warnings.modal-cancel',
		defaultMessage: 'Cancel',
		description:
			'Closes the warnings modal where customers can configure what warnings show in the version details page.',
	},
	warningsSetForAllVersionsInThisProject: {
		id: 'software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project',
		defaultMessage:
			'These warning settings affect all existing and future versions in this project.',
		description:
			'Explains to customers that changing this setting will apply to all versions in this project.',
	},
	updateWarningConfigFailed: {
		id: 'software-releases-manage-warnings.update-warning-config-failed',
		defaultMessage: 'Something went wrong. Please try to save again.',
		description: 'Message to display when saving warning config failed',
	},
	openPullRequests: {
		id: 'software-releases-manage-warnings.open-pull-requests',
		defaultMessage: 'Open pull requests',
		description: 'Title for a versions warning category',
	},
	openPullRequestsDescription: {
		id: 'software-releases-manage-warnings.open-pull-requests-description',
		defaultMessage: 'These issues have been marked complete but have open pull requests.',
		description:
			'When enabled this feature will show warnings when issues are complete but have open pull requests.',
	},
	openReviews: {
		id: 'software-releases-manage-warnings.open-reviews',
		defaultMessage: 'Open reviews',
		description:
			'Title for a versions warning category. (review is the entity only for FishEye/Crucible integration with Jira, that is different from pull request).',
	},
	openReviewsDescription: {
		id: 'software-releases-manage-warnings.open-reviews-description',
		defaultMessage: 'These issues have been marked complete but have open reviews.',
		description:
			'When enabled this feature will show warnings when issues are complete but have open reviews. (review is the entity only for FishEye/Crucible integration with Jira, that is different from pull request).',
	},
	unreviewedCode: {
		id: 'software-releases-manage-warnings.unreviewed-code',
		defaultMessage: 'Unreviewed code',
		description: 'Title for a versions warning category',
	},
	unreviewedCodeDescription: {
		id: 'software-releases-manage-warnings.unreviewed-code-description',
		defaultMessage:
			'These issues have been marked complete but the commits are not part of a pull request or review.',
		description:
			'When enabled this feature will show warnings when issues are complete but are not part of a pull request or review.',
	},
	failingBuilds: {
		id: 'software-releases-manage-warnings.failing-builds',
		defaultMessage: 'Failing builds',
		description: 'Title for a versions warning category',
	},
	failingBuildsDescription: {
		id: 'software-releases-manage-warnings.failing-builds-description',
		defaultMessage: 'These issues have been marked complete but have failing builds.',
		description:
			'When enabled this feature will show warnings when issues are complete but have failing builds',
	},
	warningDescription: {
		id: 'software-releases-manage-warnings.warning-description',
		defaultMessage:
			"Warnings will be displayed when the status of a Jira issue doesn't accurately reflect related development activity.",
		description: 'The description of version warnings.',
	},
	openPullRequestsDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-manage-warnings.open-pull-requests-description-issue-terminology-refresh-m4',
		defaultMessage: 'These work items have been marked complete but have open pull requests.',
		description:
			'When enabled this feature will show warnings when issues are complete but have open pull requests.',
	},
	openReviewsDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-manage-warnings.open-reviews-description-issue-terminology-refresh-m4',
		defaultMessage: 'These work items have been marked complete but have open reviews.',
		description:
			'When enabled this feature will show warnings when issues are complete but have open reviews. (review is the entity only for FishEye/Crucible integration with Jira, that is different from pull request).',
	},
	unreviewedCodeDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-manage-warnings.unreviewed-code-description-issue-terminology-refresh-m4',
		defaultMessage:
			'These work items have been marked complete but the commits are not part of a pull request or review.',
		description:
			'When enabled this feature will show warnings when issues are complete but are not part of a pull request or review.',
	},
	failingBuildsDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-manage-warnings.failing-builds-description-issue-terminology-refresh-m4',
		defaultMessage: 'These work items have been marked complete but have failing builds.',
		description:
			'When enabled this feature will show warnings when issues are complete but have failing builds',
	},
	warningDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-manage-warnings.warning-description-issue-terminology-refresh-m4',
		defaultMessage:
			"Warnings will be displayed when the status of a Jira work item doesn't accurately reflect related development activity.",
		description: 'The description of version warnings.',
	},
	warningsSetForAllVersionsInThisProjectGalaxia: {
		id: 'software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project-galaxia',
		defaultMessage: 'These warning settings affect all existing and future versions in this space.',
		description:
			'Explains to customers that changing this setting will apply to all versions in this project.',
	},
});
export default messages;
